import React, { Component } from 'react';
import moment from 'moment';
import CommonServices from '../../services/axioServices/apiServices/CommonServices.js';
import { isValidForm } from '../../utils/validation/CommonValidator.js';
import { CommonSuccessMessages, CommonValidationMessages } from '../../utils/Messages.js';
import SwalServices from '../../services/swalServices/SwalServices.js';
import FirstPageReceiptPaymentEntry from '../../components/account/FirstPageReceiptPaymentEntry.js';
import SecondPageReceiptPaymentEntry from '../../components/account/SecondPageReceiptPaymentEntry.js';
import AccountServices from '../../services/axioServices/apiServices/AccountServices.js';

class ReceiptEntry extends Component {
    constructor(props) {
        super(props);
        this.commonServices = new CommonServices();
        this.SwalServices = new SwalServices();
        this.accountServices = new AccountServices();
        this.state = {
            isGridView: true,
            index: null,
            isLoading: false,
            tableStatus: "",
            isadjustmentDetailsEditing: false,
            isDisabledAdjustmentFields: true,
            setPendingInvoiceModal: false,
            partyDropdownList: [],
            daybookList: [],
            pendingInvoiceList: [],
            adjustmentDetailsList: [],
            receiptEntryList: [],
            pageName: "receiptEntry",
            filterDetails: {
                search: "",
                arrangedBy: "",
                from: 'ReceiptEntry'
            },
            receiptDetails: {
                paymentReceiptId: "",
                voucherNo: "",
                date: "",
                partyId: "",
                closingBalance: "",
                partyBankNameOrPayto: "",
                bankId: "",
                chqNo: "",
                creditAmount: "",
                narration1: "",
                narration2: "",
                narration3: "",
                maintainAc: "",
                pendingAmount: 0,
                entryType: "Receipt",
                from: "ReceiptEntry"
            },
            adjustmentDetails: {
                adjType: "",
                invoiceNo: "",
                invoiceAmount: "0",
                adjAmount: "0",
                gstInvoiceFinishGoodsId: null,
                gstRMInvoiceId: null,
                gstPMInvoiceId: null,
                grandTotalAmountInvoice: 0,
            },
            arrangedByList: [
                { arrangedBy: "Voucher No.", value: "voucherNo" },
                { arrangedBy: "Date", value: "date" },
                { arrangedBy: "Party Name", value: "partyName" },
                { arrangedBy: "Cheque No", value: "chqNo" },
                { arrangedBy: "Amount.", value: "creditAmount" },
            ],
            bankList: [
                { bankName: "DTDC", value: "dtdc" },
                { bankName: "MADHUR", value: "madhur" },
                { bankName: "SPEED POST", value: "speedPost" },
                { bankName: "TRACKON", value: "trackOn" },
                { bankName: "OTHER", value: "other" },
            ],
            adjTypeList: [
                { adjType: "Adj. Ref", value: "adjRef" },
                { adjType: "On A/C", value: "onA/C" },
            ],
            validationRules: {
                date: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "date"
                        ),
                    },
                ],
                bankId: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "Bank Name"
                        ),
                    },
                ],
                partyId: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "party name"
                        ),
                    },
                ],
                creditAmount: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "amount"
                        ),
                    },
                ],

            },
            validState: {
                isValid: true,
                error: {},
            },
            validationRulesForAdjustmentDetails: {
                adjType: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "adjustment type"
                        ),
                    },
                ],
                adjAmount: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "adjustment amount"
                        ),
                    },
                    {
                        type: "number",
                        message: "adjustment amount must be grater then 0.",
                    },
                    {
                        type: "graterThenZero",
                        message: 'adjustment amount must be grater then 0.',
                    },
                ],
            },
            validStateForAdjustmentDetails: {
                isValid: true,
                error: {},
            },
        };
    }

    componentDidMount() {
        this.getAllReceiptEntry()
    }

    getAllReceiptEntry = () => {
        this.setState({ tableStatus: "Loading..." })
        let request = this.state.filterDetails
        this.accountServices.getAllReceiptEntry(request).then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                if (response.responseData.length === 0) {
                    this.setState({ tableStatus: "No Record Found" })
                } else {
                    this.setState({ tableStatus: "" })
                }
                this.setState({ receiptEntryList: response.responseData }, () => {
                    this.getAllPartyDropdown()
                })
            } else {
                this.setState({ tableStatus: "" })
                this.getAllPartyDropdown();
                this.SwalServices.Error(response.Message);
            }
        });
    };

    getAllPartyDropdown = () => {
        this.commonServices.getAllPartyDropdown().then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                let res = response.responseData;
                let dropdownItems = res.map((item) => ({
                    label: item.partyName,
                    value: item._id,
                    maintainAc: item.maintainAc,
                }));
                this.setState({ partyDropdownList: dropdownItems }, () => {
                    this.getAllDaybooks()
                });
            } else {
                this.getAllDaybooks()
                this.SwalServices.Error(
                    response.Message
                );
            }
        });
    };

    getAllDaybooks = () => {
        let request = ''
        this.commonServices.getAllDaybooks(request).then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                const filteredBooks = response.responseData.filter(book => book.bookType === "Bank Book" || book.bookType === "Cash Book");
                let dropdownItems = filteredBooks.map((item) => ({
                    label: item.daybookName,
                    value: item._id,
                }));
                this.setState({ daybookList: dropdownItems });
            } else {
                this.SwalServices.Error(response.Message);
            }
        });
    };

    getReceiptEntryVoucherNo = () => {
        this.accountServices.getReceiptEntryVoucherNo().then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                let details = this.state.receiptDetails
                details.voucherNo = response.responseData.voucherNo
                details.date = moment(new Date()).format('yyyy-MM-DD')
                this.setState({ receiptDetails: details }, () => {
                    this.closeGridView()
                })
            } else {
                this.SwalServices.Error(response.Message);
            }
        });
    }

    isValidAllFields = () => {
        const newValidState = isValidForm(
            this.state.receiptDetails,
            this.state.validationRules,
            this.state.validState
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    };

    closeGridView = () => {
        this.setState({ isGridView: false });
    };

    openGridView = () => {
        this.resetForm();
        this.resetAdjustmentDetails()
        this.setState({ isGridView: true, isEditing: false });
    };

    resetAdjustmentDetails = () => {
        let validState = this.state.validStateForAdjustmentDetails
        validState.error = {}
        validState.isValid = true
        let adjustmentDetails = this.state.adjustmentDetails
        adjustmentDetails.adjType = ""
        adjustmentDetails.invoiceNo = ""
        adjustmentDetails.invoiceAmount = "0"
        adjustmentDetails.adjAmount = "0"
        this.setState({ adjustmentDetails: adjustmentDetails, validStateForAdjustmentDetails: validState });
    }

    resetForm = () => {
        let validState = this.state.validState
        validState.isValid = true
        validState.error = {}

        let filterDetails = this.state.filterDetails
        filterDetails.search = ""
        filterDetails.arrangedBy = ""

        let receiptDetails = this.state.receiptDetails
        receiptDetails.date = ""
        receiptDetails.voucherNo = ""
        receiptDetails.partyId = ""
        receiptDetails.closingBalance = ""
        receiptDetails.partyBankNameOrPayto = ""
        receiptDetails.bankName = ""
        receiptDetails.chqNo = ""
        receiptDetails.creditAmount = ""
        receiptDetails.narration1 = ""
        receiptDetails.narration2 = ""
        receiptDetails.narration3 = ""
        receiptDetails.bankId = ""
        receiptDetails.pendingAmount = 0
        receiptDetails.paymentReceiptId = ""

        this.setState({ filterDetails: filterDetails, receiptDetails: receiptDetails, validState: validState, adjustmentDetailsList: [] }, () => {
            this.getAllReceiptEntry()
        }, () => {
            this.resetAdjustmentDetails()
        });
    }

    handleChange = (event, name, section) => {
        let value = event.target.value;
        if (section === "filterDetails") {
            let details = this.state.filterDetails;
            details[name] = value.toUpperCase();
            this.setState({ filterDetails: details }, () => {
                this.getAllReceiptEntry()
            });
        }
        else if (section === "accountDetails") {
            let details = this.state.receiptDetails;
            details[name] = value.toUpperCase();
            if (this.state.receiptDetails.maintainAc === 'B' && name === 'creditAmount' && Number(details.creditAmount) > 0) {
                this.setState({ isDisabledAdjustmentFields: false })
                details.pendingAmount = details.creditAmount
                if (this.state.adjustmentDetailsList.length > 0) {
                    this.setState({ adjustmentDetailsList: [] })
                }
            }
            this.setState({ receiptDetails: details });
        }
        else if (section === "adjustmentDetails") {
            let details = this.state.adjustmentDetails;
            details[name] = value.toUpperCase();
            this.setState({ adjustmentDetails: details });
        }
    };

    handleDropDownChange = (event, name, section) => {
        const select = event.target.value;
        if (section === "filterDetails") {
            let details = this.state.filterDetails;
            details[name] = select;
            this.setState({ filterDetails: details }, () => [
                this.getAllReceiptEntry()
            ]);
        }
        else if (section === "accountDetails") {
            let details = this.state.receiptDetails;
            details[name] = select;
            this.setState({ receiptDetails: details });
        }
        else if (section === "adjustmentDetails") {
            let details = this.state.adjustmentDetails;
            details[name] = select;
            this.setState({ adjustmentDetails: details }, () => {
                if (name === 'adjType' && select === 'Adj. Ref') {
                    this.getAllPendingInvoiceByPartyId(this.state.receiptDetails.partyId)
                } else {
                    let details = this.state.adjustmentDetails
                    details.invoiceNo = ''
                    details.invoiceAmount = '0'
                    details.adjAmount = '0'
                    details.gstInvoiceFinishGoodsId = null
                    details.gstPMInvoiceId = null
                    details.gstRMInvoiceId = null
                    this.setState({ adjustmentDetails: details })
                }
            });
        }
    };

    setFilterParameters = (selected, drpIdentity) => {
        let details = this.state.receiptDetails;
        details[drpIdentity] = selected.value;
        if (drpIdentity === 'partyId') {
            details.maintainAc = selected.maintainAc
            this.getRunningBalanceByPartyId(selected.value)
        }
        this.setState({ receiptDetails: details }, () => {
            if (this.state.receiptDetails.maintainAc === 'B' && Number(this.state.receiptDetails.creditAmount) > 0) {
                this.setState({ isDisabledAdjustmentFields: false })
            }
        });
    };

    getRunningBalanceByPartyId = (id) => {
        this.accountServices.getRunningBalanceByPartyId(id).then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                let closingBalance = JSON.stringify(response.responseData.closingBalance)
                let closingBalanceDRCR = response.responseData.closingBalanceDRCR
                let details = this.state.receiptDetails
                details.closingBalance = closingBalance + ' ' + closingBalanceDRCR
                this.setState({ receiptDetails: details })
            } else {
                this.SwalServices.Error(response.Message);
            }
        });
    }

    getAllPendingInvoiceByPartyId = (id) => {
        this.accountServices.getAllPendingInvoiceByPartyId(id).then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                this.setState({ pendingInvoiceList: response.responseData }, () => {
                    this.setState({ setPendingInvoiceModal: true })
                })
            } else {
                this.SwalServices.Error(response.Message);
            }
        });
    }

    setOpenModel = () => {
        this.setState({ setPendingInvoiceModal: !this.state.setPendingInvoiceModal });
    };

    selectInvoiceFromPendingInvoice = (item) => {
        let adjustmentDetails = this.state.adjustmentDetails
        adjustmentDetails.invoiceAmount = item.pendingAmount
        adjustmentDetails.invoiceNo = item.invoiceNo
        adjustmentDetails.gstInvoiceFinishGoodsId = item.gstInvoiceFinishGoodsId ? item.gstInvoiceFinishGoodsId : null
        adjustmentDetails.gstRMInvoiceId = item.gstRMInvoiceId ? item.gstRMInvoiceId : null
        adjustmentDetails.gstPMInvoiceId = item.gstPMInvoiceId ? item.gstPMInvoiceId : null
        adjustmentDetails.grandTotalAmountInvoice = item.grandTotal
        if (Number(item.pendingAmount) >= Number(this.state.receiptDetails.creditAmount)) {
            adjustmentDetails.adjAmount = this.state.receiptDetails.creditAmount
        } else if (Number(item.pendingAmount) < Number(this.state.receiptDetails.creditAmount)) {
            adjustmentDetails.adjAmount = item.pendingAmount
        }

        if (this.state.adjustmentDetailsList.length > 0 && Number(item.pendingAmount) !== Number(adjustmentDetails.adjAmount)) {
            let pendingAmount = this.state.adjustmentDetailsList.reduce((sum, item) => sum + Number(item.adjAmount), 0);
            adjustmentDetails.adjAmount = adjustmentDetails.adjAmount - pendingAmount
        }

        this.setState({ adjustmentDetails: adjustmentDetails }, () => {
            this.setState({ setPendingInvoiceModal: false })
        })
    }

    isValidAllFieldsForAdjustmentDetails = () => {
        const newValidState = isValidForm(
            this.state.adjustmentDetails,
            this.state.validationRulesForAdjustmentDetails,
            this.state.validStateForAdjustmentDetails
        );
        this.setState({ validStateForAdjustmentDetails: newValidState });
        return newValidState.isValid;
    };

    saveDatainAdjustmentTable = () => {
        let list = [...this.state.adjustmentDetailsList];
        let details = { ...this.state.adjustmentDetails };
        let isValidAllFieldsForAdjustmentDetails = this.isValidAllFieldsForAdjustmentDetails()
        if (isValidAllFieldsForAdjustmentDetails) {
            if (this.state.index >= 0 && this.state.index !== null && this.state.index !== undefined) {
                list[this.state.index] = details
            } else {
                list.push(details);
            }
            this.setState({ adjustmentDetailsList: list, index: null, isadjustmentDetailsEditing: false }, () => {
                this.calculatePendingAmount()
            })
        }
    };

    calculatePendingAmount = () => {
        let list = this.state.adjustmentDetailsList
        let pendingAmount = list.reduce((sum, item) => sum + Number(item.adjAmount), 0);
        let receiptDetails = this.state.receiptDetails
        receiptDetails.pendingAmount = Number(receiptDetails.creditAmount) - Number(pendingAmount)
        this.setState({ receiptDetails: receiptDetails }, () => {
            this.resetAdjustmentDetails()
        })
    }

    editAdjustmentDetails = (index, item) => {
        let details = this.state.adjustmentDetails
        details.adjAmount = item.adjAmount
        details.invoiceNo = item.invoiceNo
        details.adjType = item.adjType
        details.invoiceAmount = item.invoiceAmount
        details.gstInvoiceFinishGoodsId = item.gstInvoiceFinishGoodsId ? item.gstInvoiceFinishGoodsId : null
        details.gstRMInvoiceId = item.gstRMInvoiceId ? item.gstRMInvoiceId : null
        details.gstPMInvoiceId = item.gstPMInvoiceId ? item.gstPMInvoiceId : null
        this.setState({ adjustmentDetails: details, index: index, isadjustmentDetailsEditing: true })
    }

    deleteAdjustmentDetails = (index) => {
        let list = [...this.state.adjustmentDetailsList];
        list.splice(index, 1);
        this.setState({ adjustmentDetailsList: list }, () => {
            this.calculatePendingAmount()
        });
    }

    addEditReceiptEntry = () => {
        let isValidAllFields = this.isValidAllFields();
        if (isValidAllFields) {
            this.setState({ isLoading: true }, () => {
                if (Number(this.state.receiptDetails.pendingAmount) === 0) {
                    let request = {
                        receiptDetails: this.state.receiptDetails,
                        adjustmentDetailsList: this.state.adjustmentDetailsList
                    }
                    this.accountServices.addEditReceiptEntry(request).then((response) => {
                        if (response.statusCode === 200 && response.responseData != null) {
                            this.SwalServices.Success(response.Message);
                            this.setState({ isGridView: true, isLoading: false }, () => {
                                this.resetForm()
                                this.getAllReceiptEntry()
                            })
                        } else {
                            this.SwalServices.Error(response.Message);
                            this.setState({ isLoading: false })
                        }
                    });
                } else {
                    this.SwalServices.Alert('Please Adjust the Amount Properly')
                    this.setState({ isLoading: false })
                }
            })
        }
    }

    getReceiptDetailsByReceiptId = (id) => {
        this.accountServices.getReceiptDetailsByReceiptId(id).then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                let res = response.responseData
                let details = this.state.receiptDetails
                details.voucherNo = res.receiptDetails.voucherNo
                details.date = moment(res.receiptDetails.date).format('yyyy-MM-DD')
                details.partyId = res.receiptDetails.partyId
                details.partyBankNameOrPayto = res.receiptDetails.partyBankNameOrPayto
                details.bankId = res.receiptDetails.bankId ? res.receiptDetails.bankId : ""
                details.chqNo = res.receiptDetails.chqNo
                details.creditAmount = Number(res.receiptDetails.creditAmount).toFixed(2)
                details.narration1 = res.receiptDetails.narration1
                details.narration2 = res.receiptDetails.narration2
                details.narration3 = res.receiptDetails.narration3
                details.paymentReceiptId = res.receiptDetails._id

                let list = res.adjustmentDetailsList
                list.map(item => {
                    item.isFromDB = true
                    return item
                })

                if (res.adjustmentDetailsList.length > 0) {
                    this.setState({ isDisabledAdjustmentFields: false })
                }
                this.setState({ receiptDetails: details, adjustmentDetailsList: list }, () => {
                    this.setState({ isGridView: false })
                })
            } else {
                this.SwalServices.Error(response.Message);
            }
        });
    }

    deleteReceiptDetailsByReceiptId = (id) => {
        this.SwalServices.Confirm(
            "",
            ``,
            CommonSuccessMessages.Yes_Text,
            CommonSuccessMessages.No_Text,
            `Are you sure you want to delete this Receipt ?`
        ).then((response) => {
            if (response === true) {
                this.accountServices.deleteReceiptDetailsByReceiptId(id).then((response) => {
                    if (response.statusCode === 200 && response.responseData != null) {
                        this.getAllReceiptEntry()
                        this.SwalServices.Success(response.Message);
                    } else {
                        this.SwalServices.Error(response.Message);
                    }
                });
            }
        });
    }

    render() {
        return (
            <div className='ReceiptEntry-page'>
                {/* First Page  */}
                {this.state.isGridView === true ? (
                    <FirstPageReceiptPaymentEntry
                        filterDetails={this.state.filterDetails}
                        arrangedByList={this.state.arrangedByList}
                        handleChange={this.handleChange.bind(this)}
                        handleDropDownChange={this.handleDropDownChange.bind(this)}
                        closeGridView={this.closeGridView.bind(this)}
                        getVoucherNo={this.getReceiptEntryVoucherNo.bind(this)}
                        receiptEntryList={this.state.receiptEntryList}
                        getReceiptDetailsByReceiptId={this.getReceiptDetailsByReceiptId.bind(this)}
                        deleteReceiptDetailsByReceiptId={this.deleteReceiptDetailsByReceiptId.bind(this)}
                        pageName={this.state.pageName}
                        tableStatus={this.state.tableStatus}
                    />
                ) : null}

                {/* Second Page  */}
                {this.state.isGridView === false ? (
                    <SecondPageReceiptPaymentEntry
                        pageName={this.state.pageName}
                        accountDetails={this.state.receiptDetails}
                        adjustmentDetails={this.state.adjustmentDetails}
                        handleChange={this.handleChange.bind(this)}
                        handleDropDownChange={this.handleDropDownChange.bind(this)}
                        daybookList={this.state.daybookList}
                        adjTypeList={this.state.adjTypeList}
                        setFilterParameters={this.setFilterParameters.bind(this)}
                        partyDropdownList={this.state.partyDropdownList}
                        openGridView={this.openGridView.bind(this)}
                        validationRules={this.state.validationRules}
                        validState={this.state.validState}
                        addEditEntry={this.addEditReceiptEntry.bind(this)}
                        resetForm={this.resetForm.bind(this)}
                        resetAdjustmentDetails={this.resetAdjustmentDetails.bind(this)}
                        isDisabledAdjustmentFields={this.state.isDisabledAdjustmentFields}
                        setOpenModel={this.setOpenModel.bind(this)}
                        setPendingInvoiceModal={this.state.setPendingInvoiceModal}
                        pendingInvoiceList={this.state.pendingInvoiceList}
                        selectInvoiceFromPendingInvoice={this.selectInvoiceFromPendingInvoice.bind(this)}
                        saveDatainAdjustmentTable={this.saveDatainAdjustmentTable.bind(this)}
                        adjustmentDetailsList={this.state.adjustmentDetailsList}
                        validStateForAdjustmentDetails={this.state.validStateForAdjustmentDetails}
                        editAdjustmentDetails={this.editAdjustmentDetails.bind(this)}
                        isadjustmentDetailsEditing={this.state.isadjustmentDetailsEditing}
                        deleteAdjustmentDetails={this.deleteAdjustmentDetails.bind(this)}
                        isLoading={this.state.isLoading}
                    />
                ) : null}
            </div>
        );
    }
}

export default ReceiptEntry;